import Enum from './Enum.js';

export default class SalaryReviewTermType extends Enum {
  static REGULAR = new SalaryReviewTermType('REGULAR', '定期昇給');
  static EVALUATION = new SalaryReviewTermType('EVALUATION', '人事評価昇給');
}
